import { LotacaoFolhaRosto } from 'view/atendimentos/detail/folha-rosto/model'
import { LotacaoAtendimento } from 'view/atendimentos/types/AtendimentoProfissionalModel'

import { SolicitacaoExameQueryModel } from '../../objetivo/resultados-exames/model-resultadosExames'
import {
  convertSolicitacaoFromAtendToSolicitacaoWithInfo,
  convertSolicitacaoFromQueryToSolicitacaoWithInfo,
} from './converter-solicitacaoExames'
import { ItemHistoricoSolicitacaoExameModel, SolicitacaoExameModel } from './model-solicitacaoExames'

export const joinSolicitacoesExame = (
  solicitacoesExameFromQuery: SolicitacaoExameQueryModel[],
  solicitacoesExameFromAtend: SolicitacaoExameModel[],
  props?: { dataReferencia: Instant; atendimentoProfissionalId: ID; lotacao: LotacaoAtendimento | LotacaoFolhaRosto }
) => {
  const { dataReferencia, atendimentoProfissionalId, lotacao } = props ?? {}

  const solicitacoesExameWithMoreInfoFromQuery: ItemHistoricoSolicitacaoExameModel[] = convertSolicitacaoFromQueryToSolicitacaoWithInfo(
    solicitacoesExameFromQuery
  )
  const solicitacoesExameWithMoreInfoFromAtend: ItemHistoricoSolicitacaoExameModel[] = convertSolicitacaoFromAtendToSolicitacaoWithInfo(
    solicitacoesExameFromAtend,
    { dataReferencia, atendimentoProfissionalId, lotacao }
  )

  return [...solicitacoesExameWithMoreInfoFromAtend.reverse(), ...solicitacoesExameWithMoreInfoFromQuery]
}
